export default {
  bfo: {
    displayName: 'BuzzFeed'
  },
  bfreviews: {
    displayName: 'BuzzFeed Reviews'
  },
  tasty: {
    displayName: 'BuzzFeed Tasty'
  },
  asis: {
    displayName: 'BuzzFeed As Is'
  },
  perolike: {
    displayName: 'BuzzFeed Pero Like'
  },
  cocoabutter: {
    displayName: 'BuzzFeed Cocoa Butter'
  },
  huffpost: {
    displayName: 'HuffPost'
  }
};
